/**
 * Package Explorer Feature Module
 *
 * Registers the package-explorer workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'package-explorer',
  lazyWorkspaceTab(() => import('./components/PackageExplorerTab').then((m) => ({ default: m.PackageExplorerTab }))),
);

export { createDefaultPackageExplorerContent, findExistingPackageExplorerTab } from './types';
